import { render, staticRenderFns } from "./indexCopy.vue?vue&type=template&id=5784396c"
import script from "./indexCopy.vue?vue&type=script&lang=js"
export * from "./indexCopy.vue?vue&type=script&lang=js"
import style0 from "./indexCopy.vue?vue&type=style&index=0&id=5784396c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports